import { updateAuthToken } from '../state/key/keySlice';

const fetchParameter = async (parameterName) => {
    const params = {
      Name: parameterName,
      WithDecryption: true, // If the parameter is encrypted, set this to true
    };
  
    try {
      // const data = await ssm.getParameter(params).promise();
      // console.log("Parameter Value: ======>", data);
      // return data.Parameter.Value;
      return process.env.GATSBY_AUTH_TOKEN
    } catch (error) {
      console.error('Error fetching parameter:', error);
      return null;
    }
};

const initializeAuthToken = async (store) => {
    const authToken = await fetchParameter("GATSBY_AUTH_TOKEN_UAT");
    store.dispatch(updateAuthToken(authToken));
}
  
export {
    initializeAuthToken
};